import { Micro } from 'effect';
import { getStoredAuthUrlValues } from '@forgerock/sdk-oidc';
export function createValuesµ(code, config, state, endpoint, options) {
    return Micro.sync(() => {
        const storedValues = getStoredAuthUrlValues(config.clientId, options?.prefix);
        return {
            code,
            config,
            state,
            storedValues,
            endpoint,
        };
    });
}
export function handleTokenResponseµ(data, error) {
    if (error) {
        let message;
        if ('status' in error) {
            message = 'error' in error ? error.error : JSON.stringify(error.data);
        }
        else if ('message' in error) {
            message = error.message;
        }
        return Micro.fail({
            error: 'Token Exchange failure',
            message: message || 'Unknown error during token exchange',
            type: 'exchange_error',
        });
    }
    if (!data) {
        return Micro.fail({
            error: 'Token Exchange failure',
            message: 'No data returned from token exchange',
            type: 'exchange_error',
        });
    }
    return Micro.succeed(data);
}
export function validateValuesµ({ code, config, state, storedValues, endpoint, }) {
    if (!storedValues || storedValues.state !== state) {
        const err = {
            error: 'State mismatch',
            message: 'The provided state does not match the stored state. This is likely due to passing in used, returned, authorize parameters.',
            type: 'state_error',
        };
        return Micro.fail(err);
    }
    return Micro.succeed({
        code,
        config,
        endpoint,
        ...(storedValues.verifier && { verifier: storedValues.verifier }), // Optional PKCE
    });
}
//# sourceMappingURL=exchange.utils.js.map